import { render, staticRenderFns } from "./attachmentUpload1.vue?vue&type=template&id=5b434a08&scoped=true&"
import script from "./attachmentUpload1.vue?vue&type=script&lang=js&"
export * from "./attachmentUpload1.vue?vue&type=script&lang=js&"
import style0 from "./attachmentUpload1.vue?vue&type=style&index=0&id=5b434a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b434a08",
  null
  
)

export default component.exports